<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <div class="texto-titulo-formulario">
                Empresas
            </div>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="drag-drop-container">
                <div class="sucursales-list">
                    <!-- <h6>Empresas Disponibles</h6> -->
                    <div class="texto-titulo-dd">
                        Empresas Disponibles
                    </div>
                    <div class="sucursales-box" @dragover.prevent @drop="onDropDisponible">
                        <div v-for="sucursal in sucursalesDisponibles" :key="sucursal.id" draggable="true"
                            @dragstart="startDrag($event, sucursal)" class="sucursal-item">
                            {{ sucursal.nombre }} (ID: {{ sucursal.codigo }})
                        </div>
                    </div>
                </div>
                <div class="sucursales-arrows">
                    <button class="btn btn-sm btn-outline-dark" @click="moverTodosDerecha">
                        <i class="fas fa-angle-double-right"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-dark mt-2" @click="moverTodosIzquierda">
                        <i class="fas fa-angle-double-left"></i>
                    </button>
                </div>
                <div class="sucursales-list">
                    <!-- <h6>Empresas Asignadas</h6> -->
                    <div class="texto-titulo-dd">
                        Empresas Asignadas
                    </div>
                    <div class="sucursales-box" @dragover.prevent @drop="onDropAsignada">
                        <div v-for="sucursal in sucursalesAsignadas" :key="sucursal.id" draggable="true"
                            @dragstart="startDrag($event, sucursal)" class="sucursal-item">
                            {{ sucursal.nombre }} (ID: {{ sucursal.codigo }})
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-3 mt-4 mb-3">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="volver">
                Anterior
            </button>
        </div>
        <div class="col-sm-9 mt-4 mb-3">
            <button v-if="sucursalesAsignadas.length != 0" type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="guardar_info">Siguiente</button>
            <button v-else type="button" class="btn btn-sm btn-outline-dark btn-block" disabled>Siguiente</button>
        </div>
    </b-row>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'

    export default {
        name: 'DadSucursales',
        computed: {
            ...mapState(['sucursales', 'objeto_usuario'])
        },
        data() {
            return {
                sucursalesDisponibles: [],
                sucursalesAsignadas: [],
                btn_siguiente: false,
            }
        },
        methods: {
            startDrag(evt, sucursal) {
                evt.dataTransfer.dropEffect = 'move'
                evt.dataTransfer.effectAllowed = 'move'
                evt.dataTransfer.setData('sucursalId', sucursal.codigo.toString())
            },
            onDropDisponible(evt) {
                const sucursalId = evt.dataTransfer.getData('sucursalId')
                const sucursal = this.sucursalesAsignadas.find(s => s.codigo.toString() === sucursalId)
                if (sucursal) {
                    this.sucursalesAsignadas = this.sucursalesAsignadas.filter(s => s.codigo.toString() !== sucursalId)
                    this.sucursalesDisponibles.push(sucursal)
                }
            },
            onDropAsignada(evt) {
                const sucursalId = evt.dataTransfer.getData('sucursalId')
                const sucursal = this.sucursalesDisponibles.find(s => s.codigo.toString() === sucursalId)
                if (sucursal) {
                    this.sucursalesDisponibles = this.sucursalesDisponibles.filter(s => s.codigo.toString() !== sucursalId)
                    this.sucursalesAsignadas.push(sucursal)
                }
            },
            moverTodosDerecha() {
                if (this.sucursalesDisponibles.length > 0) {
                    this.sucursalesAsignadas = [...this.sucursalesAsignadas, ...this.sucursalesDisponibles]
                    this.sucursalesDisponibles = []
                }
            },
            moverTodosIzquierda() {
                if (this.sucursalesAsignadas.length > 0) {
                    this.sucursalesDisponibles = [...this.sucursalesDisponibles, ...this.sucursalesAsignadas]
                    this.sucursalesAsignadas = []
                }
            },
            guardar_info() {
                // Guardar las empresas asignadas en Vuex
                this.set_usuario_datos_empresas(this.sucursalesAsignadas);

                // Continuar al siguiente paso
                this.$emit('siguiente');
            },
            async obtener_empresas() {
                let f = {
                    api: `empresas`
                }

                let r = await this.obtener_data(f)
                this.sucursalesDisponibles = r
            },
            recuperarDatosDeVuex() {
                // Verificar si existen datos en Vuex
                if (this.objeto_usuario && this.objeto_usuario.datos_empresas && this.objeto_usuario.datos_empresas.length > 0) {
                    // Si hay empresas asignadas, moverlas a sucursalesAsignadas
                    this.sucursalesAsignadas = [...this.objeto_usuario.datos_empresas];

                    // Filtrar las empresas disponibles para no mostrar las ya asignadas
                    if (this.sucursalesDisponibles.length > 0) {
                        const idsAsignados = this.sucursalesAsignadas.map(s => s.codigo.toString());
                        this.sucursalesDisponibles = this.sucursalesDisponibles.filter(
                            s => !idsAsignados.includes(s.codigo.toString())
                        );
                    }
                }
            },
            volver() {
                this.$emit('anterior')
            },
            ...mapActions(['obtener_data']),
            ...mapMutations(['set_usuario_datos_empresas'])
        },
        async mounted() {
            await this.obtener_empresas();
            this.recuperarDatosDeVuex();
        },
    }
</script>

<style scoped>
    .drag-drop-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1rem;
    }

    .sucursales-list {
        flex: 1;
    }

    .sucursales-box {
        border: 1px solid #dee2e6;
        border-radius: 4px;
        /* min-height: 200px; */
        height: 300px;
        padding: 0.5rem;
        background: #f8f9fa;
        overflow: auto;
    }

    .sucursal-item {
        padding: 0.5rem;
        margin: 0.25rem 0;
        background: white;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        cursor: move;
    }

    .sucursal-item:hover {
        background: #579bd7;
    }

    .sucursales-arrows {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 1rem;
        margin-top: 120px;
    }

    .texto-titulo-formulario {
        font-size: 30px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .texto-titulo-dd {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 5px;
    }
</style>